import React from "react";
import { Link } from "react-router-dom";
import Ambassador1 from "../../../../../assets/ihn/team/ambassador1.webp";
import Ambassador2 from "../../../../../assets/ihn/team/ambassador2.webp";
import Linkedin from "../../../../../assets/logo/linkedin.webp"

/* Importing Director.css to ensure layout matches Co-Founder exactly */
import "../Director/Director.css";
import TeamLead from "../Team-Lead/TeamLead";

// const ambassadors = [
//     {
//         id: 1,
//         slug: "vasudha-sondhi",
//         name: "Vasudha Sondhi",
//         title: "Managing Director of OMPL",
//         about: "Vasudha Sondhi is a seasoned hospitality and tourism veteran currently serving as the Managing Director of the OMPL Group (Outbound Marketing Pvt. Ltd.). With over three decades of professional experience, she is widely recognized as a trailblazer in the Indian travel market, specializing in integrated sales, marketing, and PR solutions for global luxury hotels and international tourism boards. An alumna of the Institute of Hotel Management (IHM) Mumbai, Vasudha’s career is rooted in prestigious stints with the Taj Group and Hyatt, where she honed her expertise in sales and business development. Since co-founding OMPL in 2002, she has been instrumental in guiding the agency to become a premier representation house, managing a diverse portfolio that includes national tourism offices and elite hospitality brands. Beyond her corporate success, Vasudha is a dedicated advocate for women’s empowerment and sustainable tourism. She serves as the State President for the Uttarakhand Hospitality and Tourism Council under the Women Indian Chamber of Commerce and Industry (WICCI). Her commitment to social responsibility is further evidenced by her role as Chairperson of the Annapurna Charitable Foundation and as the co-founder of Parvada Bungalows, a boutique rural retreat in Nainital. Known for her visionary leadership and unlearn to learn philosophy, she continues to shape the future of curated travel experiences, bridging the gap between global brands and the evolving Indian outbound market.",
//         image: Ambassador1,
//         linkedin: "https://www.linkedin.com/in/vasudha-sondhi-7b79291/"
//     },
    // {
    //     id: 2,
    //     slug: "shantanu-lahiri",
    //     name: "Shantanu Lahiri",
    //     title: "Director - White Lotus Advisory",
    //     about: "Championing IHN’s core values through community engagement and strategic industry representation across the sector.",
    //     image: Ambassador2,
    //     linkedin: "https://www.linkedin.com/in/shantanulahiri/"
    // }
// ];

export const Ambassadors = ({ withPageMargin = false }) => {
    return (
//         <div className={withPageMargin ? "page-content" : ""}>
//             <section className="director-page">
//                 {ambassadors.map((person) => (
//                     <div className="director-container" key={person.id} style={{ marginBottom: "80px" }}>
                        
                   
//  <div className="founder-image-wrapper">
//               <img src={person.image} alt={person.name} className="founder-main-image" />
//               <a
//                 href={person.linkedin}
//                 target="_blank"
//                 rel="noreferrer"
//                 className="founder-linkedin-overlay"
//               >
//                 <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
//               </a>
//             </div>
//                         {/* RIGHT : CONTENT BOX */}
//                         <div className="director-content">
//                             <h1 className="director-title">{person.title}</h1>
//                             <h2 className="director-name">{person.name}</h2>
                            
//                             <p className="amb-bio-text">
//                                 {person.about}
//                             </p>

//                             {/* Consistent Action Link */}
//                             <div style={{ marginTop: "25px" }}>
//                                 <Link 
//                                     to={`/ambassador/${person.slug}`} 
//                                     style={{ 
//                                         textDecoration: 'none', 
//                                         color: '#861b68', 
//                                         fontWeight: '700',
//                                         textTransform: 'uppercase',
//                                         fontSize: '13px',
//                                         letterSpacing: '1.2px',
//                                         borderBottom: '2px solid #861b68',
//                                         paddingBottom: '4px'
//                                     }}
//                                 >
//                                     Full Biography
//                                 </Link>
//                             </div>
//                         </div>

//                     </div>
//                 ))}
//             </section>
//         </div>
<div className="page-content">
<TeamLead defaultTab="ambassadors" />


     </div>
  );
   
};